<header class="header mat-elevation-z8">
  <div class="header-content">
    <div class="left-group">
      <button class="menu-btn" (click)="onToggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
      <a href="">
        <img class="logoWapi" src="assets/img/logo-WAPI-Blanco.png" alt="HEADER" />
      </a>
    </div>
    <a href="">
      <img class="logoAlc" src="assets/img/LOGOESCUDOSDS-optimized.png" alt="HEADER" />
    </a>
  </div>
</header>
